const perPage = 12

interface CustomBlogArticleParams {
  filter_query?: {
    authors?: any
    categories?: any
  }
}

export const useBlogPagination = (customParams?: CustomBlogArticleParams) => {
  const config = useRuntimeConfig()
  const storyblokApi = useStoryblokApi()
  const route = useRoute()
  const currentPage = Number(route.params?.pageNumber) || 1
  const totalArticles = ref(0)
  const totalPages = computed(() => Math.ceil(totalArticles.value / perPage))

  const queryParams = {
    starts_with: 'blog/articles',
    resolve_relations: ['sb-blogpost.authors, sb-blogpost.categories'],
    per_page: perPage,
    page: currentPage,
    sort_by: 'first_published_at:desc',
    version: config.public.storyblokApiVersion as 'draft' | 'published',
  }

  const loadArticles = async () => {
    const data = await storyblokApi.get('cdn/stories', {
      ...queryParams,
      ...customParams,
    })
    totalArticles.value = Number(data.headers.total)

    if (!data.data.stories.length) {
      throw createError({
        message: 'No articles found',
        statusCode: 404,
      })
    }

    return data.data.stories
  }

  return {
    loadArticles,
    currentPage,
    totalArticles,
    totalPages,
  }
}
